exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ":host{display:flex;font-weight:600;line-height:1.2rem}:host:before{display:flex;align-self:center;content:\" >\";width:.45rem;height:.45rem;background-color:#464a4c;margin-right:.7rem}:host.sub-item{font-weight:400;margin-left:2.2rem;line-height:.8rem}:host.sub-item:before{width:.45rem;height:.45rem;border-radius:50%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["./~/bootstrap/scss/_functions.scss","./~/bootstrap/scss/_variables.scss","./src/main/webapp/content/scss/variables.scss"]}!./src/main/webapp/app/layouts/footer/plan-site/plan-site-item/plan-site-item.component.scss
// module id = 703
// module chunks = 0